import { Component, OnInit, Input } from '@angular/core';
import { VerificationQuestion, ReferenceVerificationQuestion } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';

@Component({
  selector: 'app-verification-question-grid',
  templateUrl: './verification-question-grid.component.html',
  styleUrls: ['./verification-question-grid.component.less']
})
export class VerificationQuestionGridComponent implements OnInit {

  @Input() questions : VerificationQuestion[];

  constructor() { }

  ngOnInit() {
    //order the questions array by the sort number
    this.questions.sort((a, b) => {return a.sort - b.sort})
    console.log('SORTED QUESTIONS: ', this.questions);
  }

}
